/* Seek Key — Hover Video Preview (v3 — horizontal only, quality optimized) */
(function() {
  "use strict";

  // Desktop only
  if (window.matchMedia("(hover: none)").matches) return;
  if (navigator.deviceMemory && navigator.deviceMemory < 4) return;
  var conn = navigator.connection || navigator.mozConnection;
  if (conn && (conn.saveData || conn.effectiveType === "slow-2g" || conn.effectiveType === "2g")) return;

  function initHoverVideos() {
    document.querySelectorAll(".card-wrapper").forEach(function(card) {
      if (card._hoverVideoInit) return;
      card._hoverVideoInit = true;
      var video = card.querySelector(".hover-video-steam");
      if (!video) return;
      // Skip if video is hidden (vertical cards, mobile)
      if (video.offsetParent === null) return;

      var loadTimeout = null;

      card.addEventListener("mouseenter", function() {
        // Lazy: set src from data-src on first hover
        if (!video.src && video.dataset.src) {
          video.src = video.dataset.src;
        }
        if (!video.src) return;

        if (video.readyState >= 2) {
          video.currentTime = 0;
          video.play().catch(function(){});
        } else {
          video.load();
          loadTimeout = setTimeout(function() {
            // If video hasn't loaded in 4s, give up for this hover
            loadTimeout = null;
          }, 4000);
          video.addEventListener("canplay", function onCanPlay() {
            video.removeEventListener("canplay", onCanPlay);
            if (loadTimeout) { clearTimeout(loadTimeout); loadTimeout = null; }
            video.play().catch(function(){});
          });
        }
      });

      card.addEventListener("mouseleave", function() {
        if (loadTimeout) { clearTimeout(loadTimeout); loadTimeout = null; }
        video.pause();
        video.currentTime = 0;
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHoverVideos);
  } else {
    initHoverVideos();
  }
  document.addEventListener("shopify:section:load", initHoverVideos);

  // IntersectionObserver: preload when card is near viewport
  if ("IntersectionObserver" in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var video = entry.target.querySelector(".hover-video-steam");
        if (!video || video.offsetParent === null) return;
        if (entry.isIntersecting) {
          if (!video.src && video.dataset.src) {
            video.src = video.dataset.src;
            video.preload = "metadata";
          }
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: "300px" });

    function observeCards() {
      document.querySelectorAll(".card-wrapper").forEach(function(card) {
        var video = card.querySelector(".hover-video-steam");
        if (video && video.offsetParent !== null) observer.observe(card);
      });
    }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", observeCards);
    } else {
      // Defer to ensure CSS is applied (offsetParent check)
      setTimeout(observeCards, 100);
    }
  }

  // MutationObserver: detect dynamically added cards (related products, recommendations)
  if ("MutationObserver" in window) {
    var domObserver = new MutationObserver(function(mutations) {
      var hasNewCards = false;
      mutations.forEach(function(m) {
        if (m.addedNodes.length) {
          m.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && (node.classList && node.classList.contains("card-wrapper") || node.querySelector && node.querySelector(".card-wrapper"))) {
              hasNewCards = true;
            }
          });
        }
      });
      if (hasNewCards) {
        initHoverVideos();
        if (typeof observeCards === "function") observeCards();
      }
    });
    domObserver.observe(document.body, { childList: true, subtree: true });
  }
})();